import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ChatJSPolarChart } from "../../../../Constant";
import { PolarArea } from "react-chartjs-2";
import { POLAR_CHART_DATA, POLAR_CHART_OPTION } from "../../../../Data/Charts/ChartJS";

const PolarChart = () => {
  return (
    <Col xl="6" ms="12" className="box-col-6">
      <Card>
        <CommonCardHeader title={ChatJSPolarChart} />
        <CardBody className="chart-block">
          <PolarArea id="myPolarGraph" data={POLAR_CHART_DATA} options={POLAR_CHART_OPTION} width={734} height={335} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default PolarChart;
